import { forwardRef, useImperativeHandle, useLayoutEffect, useRef } from 'react';

import { useT } from '../../../../i18n';
import { cn } from '../../../../lib/cn';

export interface TrangVanBanRef {
  html: () => string;
  chu: () => string;
}

/**
 * Trang giấy A4 của văn bản đã soạn. Đổ HTML bằng tay (không `dangerouslySetInnerHTML`) để không xung đột
 * `contentEditable`: đang sửa thì không ghi đè chỉnh sửa của người dùng, như bản cũ.
 *
 * `lan` tăng mỗi lần AI trả bản mới, để đổ lại kể cả khi HTML trùng bản trước.
 */
export const TrangVanBan = forwardRef<TrangVanBanRef, { html: string; lan: number; dangSua: boolean }>(
  function TrangVanBan({ html, lan, dangSua }, ref) {
    const { t } = useT();
    const giay = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
      if (giay.current && !dangSua) giay.current.innerHTML = html;
    }, [html, lan, dangSua]);

    useImperativeHandle(ref, () => ({
      html: () => giay.current?.innerHTML ?? '',
      chu: () => giay.current?.innerText ?? '',
    }));

    return (
      <div className="flex-1 overflow-y-auto bg-page p-4 sm:p-6">
        <div
          ref={giay}
          role="textbox"
          aria-multiline="true"
          aria-readonly={!dangSua}
          aria-label={t('vanBanSoanThao.vanBanSauSoan')}
          contentEditable={dangSua}
          suppressContentEditableWarning
          spellCheck={false}
          className={cn(
            'mvb-doc mx-auto min-h-[60vh] w-full max-w-[820px] rounded-lg shadow-md',
            dangSua && 'ring-2 ring-inset ring-primary-300',
          )}
        />
      </div>
    );
  },
);
